import React, { useCallback, useEffect, useState } from 'react'
import SearshFilter from '../components/shared/SearshFilter'
import getAllCurrencies from '../apis/getAllCurrencies'
import CurrencyRow from '../components/currency/CurrencyRow'

const Currency = () => {
  const [filteredData, setFilteredData] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sortType, setSortType] = useState('creationDate')
  const [loading, setLoading] = useState(true)

  const fetchAllCurrencies = useCallback(async () => {
    setLoading(true)
    try {
      const allCurrencies = await getAllCurrencies()
      console.log(allCurrencies)
      setCurrencies(allCurrencies)
    } catch (error) {
      console.error('Failed to fetch categories', error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchAllCurrencies()
  }, [fetchAllCurrencies])

  const refresh = () => {
    fetchAllCurrencies()
  }

  useEffect(() => {
    let filtered = [...currencies]

    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.amount?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }

    if (sortType === 'alphabet') {
      filtered.sort((a, b) => parseFloat(b.amount) - parseFloat(a.amount))
    } else if (sortType === 'creationDate') {
      filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    }

    setFilteredData(filtered)
  }, [currencies, searchTerm, sortType])

  return (
    <>
      <div className="text-2xl text-blue-600 mb-4">Currencies</div>
      <SearshFilter
        type={'currency'}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortType={sortType}
        setSortType={setSortType}
        refresh={refresh}
      />

      <div className="w-full ">
        <div className="flex py-2  text-darkBlue sticky top-0 bg-lightBlue/10 z-10">
          <div className="flex-1 p-2 items-center justify-center flex">
            Currency Name
          </div>
          <div className="flex-1 p-2 items-center justify-center flex">
            Currency Code
          </div>
          <div className="flex-1 p-2 items-center justify-center flex">
            Currency Symbol
          </div>
          <div className="flex-1 p-2 items-center justify-center flex">
            Price for Dollar
          </div>
          <div className="flex-1 p-2 items-center justify-center flex">
            Creation Date
          </div>
          <div className="flex-1 p-2 items-center justify-center flex">
            Actions
          </div>
        </div>
        <div className="overflow-y-auto max-h-96">
          {loading ? (
            <div>loading ... </div>
          ) : (
            filteredData.map((currency, index) => (
              <CurrencyRow
                refresh={refresh}
                currency={currency}
                index={index}
              />
            ))
          )}
        </div>
      </div>
    </>
  )
}

export default Currency
